import React from 'react';
import { Modal } from 'antd';
import base from '../../tool/base';

class MobileMode extends React.Component {
  constructor(props) {
		super(props);
		this.state = {
			visible: false,
			url: '',
		}
	}
	componentDidMount() {
		this.getUrl();
	}
	componentWillUnmount() {
		this.setState({ visible: false });
	}
	getUrl = () => {
		base.callApi('/v5/support/helpDatas', 'GET', {}, 'json', 'text').then((data) => {
			if (data.status) {
				this.setState({ url: data.formModeUrl });
			}
		})
	}
	onOpen = () => {
		// this.setState({ visible: true });
		const { url } = this.state;
		const { onClick } = this.props;
		window.open(url);
		typeof onClick === 'function' && onClick();
	}
	onCancel = () => {
		this.setState({ visible: false });
	}
	render() { 
		const { visible } = this.state;
    return (
			<div>
				<div onClick={this.onOpen}>{this.props.children}</div>
			  <Modal
					className="cs-MobileMode"
					title="建模模板"
					visible={visible}
					footer={null}
					width={1200}
					centered
					bodyStyle={{ height: 800 }}
					destroyOnClose
					onCancel={this.onCancel}
				>
					<iframe src={this.state.url} />
				</Modal>
			</div>
    )
  }
}

export default MobileMode;


// WEBPACK FOOTER //
// ./src/components/util/Mobilemode.js